// Styles for OfferPropertiesList go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledOfferPropertiesList = styled.div`
  padding-top: ${toRem(16)};
  padding-bottom: ${toRem(64)};
`;
